// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2CkeP","title":"BackImages_title__1DyJy","images":"BackImages_images__2TLKA"};